export default __webpack_public_path__ + "static/hero-landscape-large-2048x1152-7410f0d3680db69a79a895ac24b03e3f.mp4";